// extracted by mini-css-extract-plugin
export var questionBox = "_87-0";